import { render, staticRenderFns } from "./CustomerManage.vue?vue&type=template&id=1a10221c&scoped=true"
import script from "./CustomerManage.vue?vue&type=script&lang=ts"
export * from "./CustomerManage.vue?vue&type=script&lang=ts"
import style0 from "./CustomerManage.vue?vue&type=style&index=0&id=1a10221c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a10221c",
  null
  
)

export default component.exports